import React from "react";
import { connect } from "react-redux";
import { modal } from "@mc/mc-legacy";
import CustomPageLayout from "./CustomPageLayout";
import AdminMenu from "../administrace/lists/components/AdminMenu";
import IconButton from "../components/IconButton";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";
import * as textNoteActions from "../actions/textNoteActions";
import TextNoteForm from "../administrace/forms/TextNoteForm";
import TextNoteList from "../administrace/lists/components/TextNoteList";

/**
 * Správa knihovny textů.
 */
class TextNotesPage extends React.Component {
  handleCreateTextNote = () => {
    const { dispatch } = this.props;
    dispatch(
      modal.ModalActions.show(
          TextNoteForm,
        {
          onSubmit: (data) => {
            return QSignAdminApi.createTextNote(data);
          },
          onSubmitSuccess: (result, dispatch) => {
            dispatch(modal.ModalActions.hide());
            dispatch(textNoteActions.fetchTextNotesIfNeeded(true));
          },
        },
        "Nová poznámka",
        {}
      )
    );
  };

  render() {
    return (
      <CustomPageLayout
        header
        customHeaderButton={<IconButton icon="plus" title="Nová poznámka" onClick={this.handleCreateTextNote} />}
        headerButton={false}
        searchField={false}
        title="Číselník poznámek"
        menu={<AdminMenu />}
      >
        <TextNoteList />
      </CustomPageLayout>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps)(TextNotesPage);
